import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add3",
  "use": "icon-add3-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add3\"><path d=\"M554.56 213.312a42.56 42.56 0 0 0-85.12 0v256.128H213.312a42.56 42.56 0 0 0 0 85.12h256.128v256.128a42.56 42.56 0 0 0 85.12 0V554.56h256.128a42.56 42.56 0 0 0 0-85.12H554.56V213.312z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol